import { render, staticRenderFns } from "./newsMasthead.vue?vue&type=template&id=2a7e9990&scoped=true&"
import script from "./newsMasthead.vue?vue&type=script&lang=js&"
export * from "./newsMasthead.vue?vue&type=script&lang=js&"
import style0 from "./newsMasthead.vue?vue&type=style&index=0&id=2a7e9990&scoped=true&lang=css&"
import style1 from "./newsMasthead.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e9990",
  null
  
)

export default component.exports